import React from 'react'
import classNames from 'classnames'

import NumberFormat, { FORMAT_CURRENCY } from 'cityads-v3/components/Format/NumberFormat'

import classes from './Payments.scss'

export type AccountParamProps = {
  className?: string,
  title: string,
} & (
  {
    value: number,
    currency: string,
  } | {
    value: string | JSX.Element,
    currency?: never,
  }
)

export default function AccountParam({ className, title, value, currency }: AccountParamProps): JSX.Element {
  return (
    <div className={classNames(classes.accountParam, className)}>
      <p>
        {title}
      </p>
      {
        (typeof value === 'number') ?
          (
            <NumberFormat
              number   = {value}
              format   = {FORMAT_CURRENCY}
              currency = {currency}
            />
          )
          :
          (
            <div>
              {value}
            </div>
          )
      }
    </div>
  )
}
